"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tick = void 0;
/**
 * @function tick
 * @param {number} time The wait time (in ms)
 * @description A method for waiting
 * @returns {Promise} the timed promise
 */
var tick = function (time) {
    if (time === void 0) { time = 100; }
    return new Promise(function (resolve) { return setTimeout(resolve, time); });
};
exports.tick = tick;
